import React from 'react';

const LandingPageLoading = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-gray-400 text-lg">Loading landing pages...</p>
      </div>
    </div>
  );
};

export default LandingPageLoading;
